import { UtilityService } from 'src/app/services/utility-service/utility-service';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, retry, Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
export const httpJsonPostOptions = {
  headers: new HttpHeaders({
      'Content-Type':  'application/json',

  })
};
@Injectable({
  providedIn: 'root'
})


export class
ApiserviceService {


  constructor(private httpClient: HttpClient) { }

  httpHeaders = new HttpHeaders();

  backendUrl = environment.apiURL;
customerportal=environment.customerportalurl+'answers/details/';

  getObjectData(id:number,objectname:string){
    alert("test");
    return this.httpClient.get(this.backendUrl+'entity/'+objectname+'/'+id, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }
  getallsearchfilter(suggestion:any,page:any,size:any):Observable<any>{
    console.log(suggestion)
    const params = new HttpParams()
    .set('letter', suggestion)
    .set('page', page)
    .set('size',size)
    return  this.httpClient.get(environment.apiURL+ "research", { params: params })
  }
  getallcustomerfaq(suggestion:any,page:any,size:any):Observable<any>{
    console.log(suggestion)
    const params = new HttpParams()
    .set('letter', suggestion)
    .set('page', page)
    .set('size',size)
    return  this.httpClient.get(environment.apiURL+ "CustomerAnswers", { params: params })
  }


  getallfaq(page:any,size:any): Observable<any> {
    const params = new HttpParams()
    .set('page', page)
    .set('size',size)
    return  this.httpClient.get(environment.backendurl + "getAllAnswersToCustomers",{params:params})
  }
  getallanswers(answerid:any){
    console.log(answerid)
    const params = new HttpParams()
      .set('answerid', answerid)
    return  this.httpClient.get(environment.apiURL+ "allAnswerById", { params: params })
  }
  getallkeyword(keyword:any,page:any,size:any)
  {
    const params = new HttpParams()
    .set('keyword', keyword)
    .set('page', page)
    .set('size',size)
  return  this.httpClient.get(environment.backendurl+ "allAnswersByKeyword", { params: params })
  }
  getallautosuggest(suggestion:any):Observable<any>{
    console.log(suggestion)
    const params = new HttpParams()
    .set('letter', suggestion)
    return  this.httpClient.get(environment.backendurl+ "autoSuggest", { params: params })
  }
getcontactdetails(phonenumber:any)
{
  // console.log(phonenumber)
  // const params = new HttpParams()
  // .set('phonenumber', phonenumber)
  return  this.httpClient.get(environment.apiURL+ "getContactByPhonenumber/"+phonenumber)
}
referrence_number:any=0;
getrecentIncidents(): Observable<any> {
  return  this.httpClient.get(environment.backendurl + "getrecentIncidents")

  // const params={"queryId" :   2}
  // return  this.httpClient.post(environment.apiURL + "query/run",params)
}
getByIncidentByRefno(refno:any)
{
 return this.httpClient.get(environment.backendurl + "getByIncidentByRefno/" + refno);

}

logFreeze() {
  return this.httpClient.get(environment.apiURL + "freezing");
}

  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime. ObjectDetails';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(()=>errorMessage);
  }
  private searchQuerySubject: BehaviorSubject<{ query: string, selectedDepartment: any, selectedCategory: any }> = new BehaviorSubject({ query: '', selectedDepartment: '', selectedCategory: '' });
  searchQuery$: Observable<{ query: string, selectedDepartment: any, selectedCategory: any }> = this.searchQuerySubject.asObservable();

  updateSearchQuery(query: string, selectedDepartment: string, selectedCategory: string): void {
  this.searchQuerySubject.next({ query, selectedDepartment, selectedCategory });
  }
  updatelogs(logs:any)
  {
    console.log(logs);
  return  this.httpClient.post(environment.apiURL + "payload/patch",logs);
  }
  gensysdata:any;
  subject:any;
  message:any[] = [];
  link:any[]=[];
  incidentmessage:any;
  // private componentSelectionSubject = new Subject<any>();
  // componentSelection$ = this.componentSelectionSubject.asObservable();

  // sendComponentSelection(data: any) {
  //   this.componentSelectionSubject.next(data);
  // }
}
